import { useCallback, useEffect, useRef, useState } from 'react';
import { queryHistoryResourceList, HistoryResource } from 'services/api/resource';

const pageSize = 9;
const useHistoryVideoList = (show: boolean, storeId?: string) => {
  const totalRef = useRef(Number.MAX_SAFE_INTEGER);
  const currentPageRef = useRef(1);
  const [list, setList] = useState<HistoryResource[]>([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const storeIdRef = useRef(storeId);
  storeIdRef.current = storeId;
  const fetchList = useCallback(() => {
    if (!storeIdRef.current) {
      return;
    }

    setLoading(true);
    queryHistoryResourceList({
      keyword,
      // resourceType: 2,
      storeId: storeIdRef.current,
      page: {
        pageNo: currentPageRef.current,
        pageSize,
      },
    })
      .then((res) => {
        currentPageRef.current += 1;
        setList((pre) => [...pre, ...res.data]);
        totalRef.current = res.total;
      })
      .finally(() => setLoading(false));
  }, [keyword]);
  useEffect(() => {
    if (show) {
      setKeyword('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId, show]);
  useEffect(() => {
    if (!show) return;
    currentPageRef.current = 1;
    setList([]);
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, show]);
  return {
    list,
    total: totalRef.current,
    loadMore: fetchList,
    loading,
    onSearch: setKeyword,
    hasMore: totalRef.current > list.length,
  };
};

export default useHistoryVideoList;
